"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionToolbar = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var input_checkbox_1 = require("../../components/input/input.checkbox");
var mithril_component_1 = require("../../components/mithril.component");
var sortable_1 = require("../../components/sortable/sortable");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var tag_sort_state_1 = require("../../state/tag.sort.state");
var store_1 = require("../../store");
var collection_edit_menu_1 = require("../collection.edit.menu/collection.edit.menu");
var export_menu_1 = require("../export.menu/export.menu");
var topological_editor_button_1 = require("../topological.editor.button/topological.editor.button");
var collection_toolbar_style_1 = require("./collection.toolbar.style");
(0, theme_1.addStyles)(collection_toolbar_style_1.Style);
var CollectionToolbar = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionToolbar, _super);
    function CollectionToolbar(state, cfg) {
        if (cfg === void 0) { cfg = {}; }
        var _this = _super.call(this) || this;
        _this.state = state;
        _this.editMenu = new collection_edit_menu_1.CollectionEditMenu();
        _this.exportMenu = new export_menu_1.ExportMenu(_this.state.tagExport);
        _this.sortable = new sortable_1.Sortable(tag_sort_state_1.TagSortState);
        _this.mapZoomOut = cfg.mapZoomOut;
        _this.defaultTitle = cfg.title;
        return _this;
    }
    Object.defineProperty(CollectionToolbar.prototype, "title", {
        get: function () {
            var tag = store_1.AppStore.Tag.get(page_state_1.CurrentState.inspectedTagId);
            if (tag == null) {
                return (0, i18n_1.Translate)(this.defaultTitle);
            }
            if (tag.name != null) {
                return tag.name;
            }
            return (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionToolbar.prototype, "nodes", {
        get: function () {
            var _this = this;
            var showOpenSomButton = this.mapZoomOut === false && (services_1.Services.User.isIkeAnalyst(services_1.Services.User.current) || services_1.Services.Token.has(core_api_1.IkeToken.SPAN_O_MATIC));
            var showMapModeButton = this.mapZoomOut === false && services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_MODE) && (services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)
                ? !services_1.Services.UserProfile.isReadOnly(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId))
                : false);
            if (page_state_1.CurrentState.Tag.tags.length === 0) {
                var title = this.title;
                var selectedUuid = page_state_1.CurrentState.inspectedCollectionRevision ? store_1.AppStore.CollectionSummary.get(page_state_1.CurrentState.inspectedCollectionRevision).uuid : null;
                return (0, mithril_1.m)('div', { key: 'selection-toolbar', className: collection_toolbar_style_1.CSS.container }, [
                    (0, mithril_1.m)('div', { className: collection_toolbar_style_1.CSS.title, title: title }, title),
                    showOpenSomButton ? image_button_1.ImageButton.view(icons_1.MaterialIcon.EDIT_LOCATION, { onclick: this.openSom, title: i18n_1.T.SPAN_O_MATIC, className: collection_toolbar_style_1.CSS.spanomatic }) : null,
                    showMapModeButton ? topological_editor_button_1.TopologicalEditorCollectionButton.view(page_state_1.CurrentState.inspectedTagId, selectedUuid) : null,
                    (0, mithril_1.m)('div', { className: collection_toolbar_style_1.CSS.tools }, [
                        this.sortable.view(),
                        this.mapZoomOut === false ? null : image_button_1.ImageButton.view(icons_1.MaterialIcon.ZOOM_OUT_MAP, { onclick: this.state.map.centerMap, title: i18n_1.T.TAG_ZOOM })
                    ])
                ]);
            }
            var checkboxState = {
                isSelected: function () { return _this.state.allSelected; },
                setSelected: function (val) { return page_state_1.CurrentState.Tag.selectAll(_this.state.filteredTags, val); }
            };
            return (0, mithril_1.m)('div', { key: 'selection-toolbar', className: collection_toolbar_style_1.CSS.container }, [
                input_checkbox_1.CheckBox.view(checkboxState),
                (0, mithril_1.m)('div', { className: collection_toolbar_style_1.CSS.text }, (0, i18n_1.Translate)(i18n_1.T.TAG_TITLE_SELECTION, page_state_1.CurrentState.Tag.collectionSize)),
                this.viewSelectedTools()
            ]);
        },
        enumerable: false,
        configurable: true
    });
    CollectionToolbar.prototype.openSom = function () {
        var somUrl = services_1.Services.Config.config.get('som.url');
        var jobId = page_state_1.CurrentState.inspectedTagId;
        var departmentId = services_1.Services.Department.current.objectId;
        var environment = services_1.Services.Config.env;
        var uuid = store_1.AppStore.CollectionSummary.get(page_state_1.CurrentState.inspectedCollectionRevision).uuid;
        var url = "".concat(somUrl, "?jobId=").concat(jobId, "&departmentId=").concat(departmentId, "&environment=").concat(environment, "&collection=").concat(uuid);
        var somWindow = window.open(url, '_blank');
        var sessionToken = services_1.Services.SSO.token;
        window.addEventListener('message', function (event) {
            if (somUrl !== event.origin) {
                return false;
            }
            if (event.data === 'som-loaded') {
                somWindow.postMessage(sessionToken, somUrl);
            }
            return true;
        }, false);
    };
    CollectionToolbar.prototype.viewSelectedTools = function () {
        if (!page_state_1.CurrentState.Tag.ready) {
            return spinner_1.Spinner.view();
        }
        return (0, mithril_1.m)('div', { className: collection_toolbar_style_1.CSS.tools }, [
            this.exportMenu.view(),
            this.editMenu.view()
        ]);
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], CollectionToolbar.prototype, "title", null);
    return CollectionToolbar;
}(mithril_component_1.IMithrilComponent));
exports.CollectionToolbar = CollectionToolbar;
//# sourceMappingURL=collection.toolbar.js.map